import { TChatActionModalShowPayload, EChatActionModalActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Открыть окно действия с чатом
 */
export const openChatActionModal = actionGenerator<EChatActionModalActionTypes.Open, TChatActionModalShowPayload>(
  EChatActionModalActionTypes.Open,
);

/**
 * Закрыть окно действия с чатом
 */
export const closeChatActionModal = actionGenerator<EChatActionModalActionTypes.Close, void>(
  EChatActionModalActionTypes.Close,
);
